import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const QrIcon = () => <FontAwesomeIcon icon={["fas", "qrcode"]} />

export default QrIcon;
